<template>
  <div id="DeliveriesStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <v-card class="column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">NFes não alocadas</h1>
              <v-divider v-show="!isCollapsed" vertical class="mx-2 my-1"></v-divider>
              <span v-show="!isCollapsed" class="mb-0 mt-1 font-weight-medium caption mr-2"
                >{{ filteredUnallocatedNfes.length }} itens</span
              >
              <v-tooltip right nudge-top="1">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-if="!isCollapsed"
                      v-model="selectAllNfe"
                      :disabled="filteredUnallocatedNfes.length === 0"
                      class="custom-checkbox pa-0 ma-0"
                      hide-details
                      @change="toggleSelectAllNfes"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Selecionar todas</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center">
              <span v-if="unallocatedNfes.length > 0">
                <v-tooltip v-if="!isCollapsed" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-3" @click="isCollapsed = !isCollapsed"
                      >mdi-chevron-double-left</v-icon
                    >
                  </template>
                  <span>Recolher</span>
                </v-tooltip>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed">
                      mdi-chevron-double-right
                    </v-icon>
                  </template>
                  <span>Expandir</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div v-if="isCollapsed" class="d-flex justify-space-between align-center px-3">
            <v-checkbox
              v-model="selectAllNfe"
              label="Selecionar todas"
              :disabled="filteredUnallocatedNfes.length === 0"
              class="custom-checkbox collapsed pa-0 ma-0"
              hide-details
              @change="toggleSelectAllNfes"
            ></v-checkbox>
            <v-divider vertical class="mx-1 my-1"></v-divider>
            <span class="mb-0 font-weight-medium caption">{{ filteredUnallocatedNfes.length }} itens</span>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="!isCollapsed"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryUnallocated"
            @keydown.enter="performSearch('unallocated')"
            @click:prepend-inner="performSearch('unallocated')"
          >
          </v-text-field>
          <div v-if="isUnallocatedLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div
            class="nfes-container pa-2 pt-0 justify-center"
            :style="{ height: isCollapsed ? '540px' : '530px', width: isCollapsed ? '240px' : '370px' }"
          >
            <drag-card-nfes
              :nfes="filteredUnallocatedNfes"
              :selectedNfes="selectedNfe"
              :isCollapsed="isCollapsed"
              @update:collapsed="isCollapsed = $event"
              @update:selected="updateNfeSelection"
              @update:selectAll="selectAllNfe = $event"
            />
          </div>
        </v-card>
        <div class="w-100 column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Entregas</h1>
              <v-divider vertical class="mx-2 my-1"></v-divider>
              <v-label class="pb-0 pt-1 mr-2 font-weight-medium black--text" style="font-size: 14px"
                >{{ filteredDeliveries.length }} itens</v-label
              >
              <v-checkbox
                v-model="selectAllDeliveries"
                label="Selecionar todas"
                :disabled="filteredDeliveries.length === 0"
                class="custom-checkbox collapsed pa-0 ma-0 mt-1"
                hide-details
                @change="toggleSelectAllDeliveries"
              />
            </div>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <div v-show="deliveries.length > 0" class="d-flex align-center">
            <v-text-field
              class="custom-search px-2 flex-grow-1 mr-1"
              label="Buscar"
              color="black"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              single-line
              v-model="searchQueryDeliveries"
              @keydown.enter="performSearch('deliveries')"
              @click:prepend-inner="performSearch('deliveries')"
            ></v-text-field>
          </div>
          <div v-if="isDeliveriesLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div v-if="!deliveries.length > 0" class="selected-container d-flex align-center justify-center rounded mb-2">
            <v-icon size="60" color="" style="padding-bottom: 3px">mdi-emoticon-neutral-outline</v-icon>
            <div class="d-flex flex-column ml-2">
              <span class="text-h5">Nenhuma entrega criada até o momento.</span>
              <span class="text-subtitle-1 font-weight-regular">
                Crie uma
                <a
                  class="new-import-nfe text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click="addDelivery()"
                  >nova entrega</a
                >
                para prosseguir.
              </span>
            </div>
          </div>
          <div class="d-flex justify-center align-center py-3" v-else-if="filteredDeliveries.length == 0">
            Nenhuma entrega encontrada
          </div>
          <div class="cte-container" v-else>
            <DeliveryHierarchy
              ref="DeliveryHierarchy"
              v-for="item in virtualDeliveriesList"
              :delivery="item"
              :selected="selectedDeliveries[item.id]"
              :key="item.id"
              @update:selected="updateDeliverySelection"
              @input="item.alocatedNfes = $event"
              @update:allocatedNfes="updateUnallocatedNfe"
              @removeDelivery="removeDelivery(item.id)"
            />
            <div v-if="filteredDeliveries.length" v-observe-visibility="handleDeliveriesScroll"></div>
          </div>
          <div class="px-2 mt-2"></div>
        </div>
      </div>
    </v-card>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed || isOpenConfirmDeleteComputed"
      @confirmClick="confirmClick"
      :title="titleConfirmation"
      @cancelClick="cancel"
      :body-text="bodyText"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import DragCardNfes from '@/components/ManualBoardingImport/Stepper/Step2/DragCardNfes.vue';
import DeliveryHierarchy from '@/components/ManualBoardingImport/Stepper/Step2/DeliveryHierarchy.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions } from 'vuex';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';

export default {
  name: 'DeliveriesStep',
  components: {
    DragCardNfes,
    DeliveryHierarchy,
    ConfirmDialog,
    MessagesError
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    isOpenConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isUnallocatedLoading: false,
    isDeliveriesLoading: false,
    unallocatedNfes: [],
    deliveries: [],
    deliveriesToShow: 5,
    filteredUnallocatedNfes: [],
    filteredDeliveries: [],
    selectAllDeliveries: false,
    selectedNfe: {},
    selectedDeliveries: {},
    selectAllNfe: false,
    searchQueryUnallocated: '',
    searchQueryDeliveries: '',
    isCollapsed: true,
    errors: [],
    errorsType: 'error',
    error500: null
  }),
  mounted() {
    this.fetchUnallocatedNfes();
    this.fetchDeliveries();
  },
  watch: {
    deliveries: {
      handler() {
        this.checkAndEmit();
      }
    },
    unallocatedNfes: {
      handler() {
        this.checkAndEmit();
      }
    },
    filteredUnallocatedNfes: {
      handler() {
        this.selectAllNfe ? this.toggleSelectAllNfes() : this.updateSelectAllNfe();
      }
    },
    filteredDeliveries: {
      handler() {
        this.selectAllDeliveries ? this.toggleSelectAllDeliveries() : this.updateSelectAllDeliveries();
      }
    },
    searchQueryUnallocated: {
      handler(value) {
        if (value === '') {
          this.filteredUnallocatedNfes = this.unallocatedNfes;
        }
      }
    },
    searchQueryDeliveries: {
      handler(value) {
        if (value === '') {
          this.filteredDeliveries = this.deliveries;
        }
      }
    },
    selectedDeliveries: {
      handler() {
        this.$emit('selectedDeliveriesIds', this.selectedDeliveriesIds);
      }
    }
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    virtualDeliveriesList() {
      return this.filteredDeliveries.slice(0, this.deliveriesToShow);
    },
    titleConfirmation() {
      if (this.isOpenConfirmDeleteComputed) {
        return 'Desfazer Entregas';
      } else {
        return 'Confirmar entrega(s) criadas';
      }
    },
    bodyText() {
      if (this.isOpenConfirmDeleteComputed) {
        const selectedDeliveries = this.deliveries.filter((cte) => this.selectedDeliveriesIds.includes(cte.id));
        const numbers = selectedDeliveries.map((nfe) => nfe.deliveryNumber);
        return `Confirmar dasalocar as NFes relacionadas e o descarte das entregas:${numbers.slice(0, 15)}${
          numbers.length > 15 ? '...' : ''
        }?`;
      } else {
        return `Você confirma os dados das ${this.deliveries.length} entrega(s)?`;
      }
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    isOpenConfirmDeleteComputed: {
      get() {
        return this.isOpenConfirmDelete;
      },
      set(value) {
        this.$emit('update:isOpenConfirmDelete', value);
      }
    },
    selectedNfeIds() {
      return Object.keys(this.selectedNfe).filter((id) => this.selectedNfe[id]);
    },
    selectedDeliveriesIds() {
      return Object.keys(this.selectedDeliveries).filter((id) => this.selectedDeliveries[id]);
    }
  },
  methods: {
    ...mapActions('ImportManualDeliveryStore', [
      'getAllUnallocatedNfes',
      'getAllDeliveries',
      'createNewDelivery',
      'createGroupedDeliveries',
      'deleteDelivery',
      'deleteMultipleDeliveries'
    ]),

    async fetchUnallocatedNfes() {
      try {
        this.isUnallocatedLoading = true;
        const data = await this.getAllUnallocatedNfes(this.parameterID);
        this.unallocatedNfes = data;
        this.filteredUnallocatedNfes = data;
        await this.filterNfes();
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async fetchDeliveries() {
      try {
        this.isDeliveriesLoading = true;
        const data = await this.getAllDeliveries(this.parameterID);
        this.deliveries = data;
        this.filteredDeliveries = data;
        await this.filterDeliveries();
        this.checkAndEmit();
      } catch (err) {
        console.error(err);
      } finally {
        this.isDeliveriesLoading = false;
      }
    },
    async createDelivery() {
      this.$emit('isCreateDeliveryLoading', true);
      try {
        await this.createNewDelivery(this.parameterID);
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isCreateDeliveryLoading', false);
      }
    },
    async automaticGroupedDeliveries() {
      this.$emit('isAutomaticGroupedLoading', true);
      try {
        const model = {
          processId: this.parameterID,
          nfesIds: this.selectedNfeIds
        };
        const response = await this.createGroupedDeliveries(model);
        if (response.success) {
          this.errors = ['Agrupamento realizado com sucesso!'];
          this.errorsType = 'success';
          this.selectAllNfe = false;
          this.selectedNfe = {};
        } else {
          this.errors = response.errors || ['Erro ao Agrupar Nfes'];
          this.errorsType = 'error';
        }
        this.selectAllDeliveries = false;
        await this.checkAndEmit();
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isAutomaticGroupedLoading', false);
      }
    },
    async removeDelivery(id = null, multi = false) {
      this.isDeliveriesLoading = true;
      try {
        const response = multi
          ? await this.deleteMultipleDeliveries(this.selectedDeliveriesIds)
          : await this.deleteDelivery(id);
        if (response.success) {
          this.errors = [`${multi ? 'Entregas deletadas' : 'Entrega deletada'} com sucesso!`];
          this.errorsType = 'success';
          this.selectedDeliveries = {};
        } else {
          this.errors = response.errors || ['Erro ao deletar Entrega(s)'];
          this.errorsType = 'error';
        }
        this.fetchUnallocatedNfes();
        this.fetchDeliveries();
        setTimeout(() => {
          this.checkAndEmit();
        }, 0);
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async addDelivery(automaticGrouping = false) {
      if (!automaticGrouping) {
        await this.createDelivery();
      } else {
        await this.automaticGroupedDeliveries();
      }
      this.fetchUnallocatedNfes();
      this.fetchDeliveries();
      await this.checkAndEmit();

      this.searchQueryDeliveries = '';
    },
    toggleSelectAllNfes() {
      this.selectedNfe = {};
      this.filteredUnallocatedNfes.forEach((nfe) => {
        this.$set(this.selectedNfe, nfe.id, this.selectAllNfe);
      });
      this.updateSelectAllNfe();
    },
    updateSelectAllNfe() {
      this.selectAllNfe =
        this.filteredUnallocatedNfes.length > 0
          ? this.filteredUnallocatedNfes.every((nfe) => this.selectedNfe[nfe.id])
          : false;
      this.checkAndEmit();
    },
    updateNfeSelection(id) {
      this.$set(this.selectedNfe, id, !this.selectedNfe[id]);
      this.updateSelectAllNfe();
      this.checkAndEmit();
    },
    toggleSelectAllDeliveries() {
      this.selectedDeliveries = {};
      this.filteredDeliveries.forEach((delivery) => {
        this.$set(this.selectedDeliveries, delivery.id, this.selectAllDeliveries);
      });
      this.updateSelectAllDeliveries();
    },
    updateSelectAllDeliveries() {
      this.selectAllDeliveries =
        this.filteredDeliveries.length > 0
          ? this.filteredDeliveries.every((delivery) => this.selectedDeliveries[delivery.id])
          : false;
      this.$emit('selectedDeliveriesIds', this.selectedDeliveriesIds);
      this.checkAndEmit();
    },
    updateDeliverySelection(id) {
      this.$set(this.selectedDeliveries, id, !this.selectedDeliveries[id]);
      this.updateSelectAllDeliveries();
    },
    performSearch(type) {
      if (type === 'unallocated') {
        this.filterNfes();
      } else if (type === 'deliveries') {
        this.filterDeliveries();
      }
    },
    filterNfes() {
      this.isUnallocatedLoading = true;
      const query = this.searchQueryUnallocated ? this.searchQueryUnallocated.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredUnallocatedNfes = this.unallocatedNfes;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredUnallocatedNfes = this.unallocatedNfes.filter((nfe) => {
          return (
            (nfe.number && nfe.number.toString().toLowerCase().includes(query)) ||
            (nfe.accessKey && nfe.accessKey.toString().toLowerCase().includes(query)) ||
            (nfe.nameSender && nfe.nameSender.toLowerCase().includes(query)) ||
            (nfe.cpfCnpjSender && this.transformCpfOrCnpj(nfe.cpfCnpjSender).toLowerCase().includes(query)) ||
            (nfe.nameRecipient && nfe.nameRecipient.toLowerCase().includes(query)) ||
            (nfe.cpfCnpjRecipient && this.transformCpfOrCnpj(nfe.cpfCnpjRecipient).toLowerCase().includes(query)) ||
            (nfe.price && queryNormalized && normalizeValue(maskWeight(nfe.price)).includes(queryNormalized)) || // Ensure queryNormalized is not empty
            (nfe.weight && `${maskWeight(nfe.weight)}kg`.toLowerCase().includes(query))
          );
        });
      }
      this.isUnallocatedLoading = false;
    },
    filterDeliveries() {
      this.isDeliveriesLoading = true;
      const query = this.searchQueryDeliveries ? this.searchQueryDeliveries.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      const normalizeValue = (value) => {
        return value ? value.toString().replace(/[^\d]/g, '') : '';
      };

      this.filteredDeliveries = this.deliveries.filter((delivery) => {
        return (
          (delivery.deliveryNumber && delivery.deliveryNumber.toString().toLowerCase().includes(query)) ||
          (delivery.nameSender && delivery.nameSender.toLowerCase().includes(query)) ||
          (delivery.nameRecipient && delivery.nameRecipient.toLowerCase().includes(query)) ||
          (delivery.totalPriceNfes &&
            normalizeValue(`R$ ${maskWeight(delivery.totalPriceNfes)}`).includes(queryNormalized)) || // Normalize totalPriceNfes
          (delivery?.weight && `${maskWeight(delivery?.weight || 0)}kg`.toString().toLowerCase().includes(query)) ||
          (delivery.amountNfes && delivery.amountNfes.toString().toLowerCase().includes(query))
        );
      });
      this.isDeliveriesLoading = false;
    },
    cancel() {
      this.isOpenConfirmationComputed = false;
      this.isOpenConfirmDeleteComputed = false;
    },
    confirmClick() {
      if (this.isOpenConfirmDeleteComputed) {
        this.removeDelivery(null, this.selectedDeliveriesIds);
        this.isOpenConfirmDeleteComputed = false;
      } else {
        this.$emit('confirmClick');
      }
    },
    checkAndEmit() {
      const hasDeliveries = this.deliveries.length > 0;
      const hasDeliveriesWithNfes = this.deliveries.some((cte) => cte.amountNfes > 0);
      const hasDeliveriesWithoutNfes = this.deliveries.filter((cte) => cte.amountNfes == 0);
      let message = '';
      let errorValidate = false;
      if (!hasDeliveries) {
        message = 'Crie pelo menos uma entrega';
        errorValidate = true;
      } else if (!hasDeliveriesWithNfes) {
        message = 'Nenhuma entrega com nfes alocadas';
        errorValidate = true;
      } else if (hasDeliveriesWithoutNfes.length > 0) {
        const numbers = hasDeliveriesWithoutNfes.map((nfe) => nfe.deliveryNumber).join(', ');
        message = `Entrega(s) de N° ${numbers} devem ter ao menos uma nfe alocada`;
        errorValidate = true;
      }
      this.$emit('step2Finished', errorValidate, message);

      message = '';
      errorValidate = false;
      if (this.unallocatedNfes.length === 0) {
        message = 'Nenhuma Nfe disponível para agrupamento';
        errorValidate = true;
      } else if (this.selectedNfeIds.length === 0) {
        message = 'Selecione as Nfes para agrupar';
        errorValidate = true;
      }
      this.$emit('isDisabledAutomaticGrouped', message, errorValidate);
    },
    handleDeliveriesScroll(isVisible) {
      if (!isVisible || this.deliveriesToShow >= this.filteredDeliveries.length) return;
      this.deliveriesToShow += 5;
    },
    async updateUnallocatedNfe(msg, success) {
      if (success) {
        this.errors = [msg];
        this.errorsType = 'success';
        this.selectedNfe = {};
        this.selectAllNfe = false;
      } else {
        this.errors = [msg];
        this.errorsType = 'info';
      }

      await this.fetchUnallocatedNfes();
      if (this.unallocatedNfes.length === 0) {
        this.isCollapsed = true;
      }
      await this.fetchDeliveries();
      this.checkAndEmit();
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 638px;
}

.selected-container {
  width: 100%;
  height: 520px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
}

.v-card-text-nfe,
.v-card-text-nfe h4,
.v-card-text-nfe .v-icon,
.v-card-text-nfe .row,
.v-card-text-nfe .col {
  transition: 2ms;
}

.v-card-text-nfe {
  width: auto;
  height: 42px;
  border: solid 1px #999999;
  white-space: nowrap;
}

.v-card-text-nfe h4 {
  font-size: 1.8rem;
  color: #000000;
}

.v-card-text-nfe:hover {
  border: solid 1px #4299e1;
  color: #4299e1;
}

.v-card-text-nfe:hover h4,
.v-card-text-nfe:hover .v-icon path {
  color: #4299e1;
  fill: #4299e1;
}
.cte-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-card {
  box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
  border: solid 1px #4299e1;
  color: #4299e1;
  h4,
  .v-icon path {
    color: #4299e1;
    fill: #4299e1;
  }
}
.column-title {
  width: 100%;
  text-align: left;
}

.nfes-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.nfes-container::-webkit-scrollbar,
.cte-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.nfes-container::-webkit-scrollbar-track,
.cte-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}

.nfes-container::-webkit-scrollbar-thumb,
.cte-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .nfes-container::-webkit-scrollbar-thumb:hover,
.cte-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.icon {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.new-import-nfe {
  color: #4299e1;
}
::v-deep .custom-checkbox .v-label {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;

        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}

::v-deep .custom-checkbox .collapsed .v-input--selection-controls__input {
  margin-right: 0px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
